import { render } from "./SelectionType.vue?vue&type=template&id=24ec6312&scoped=true"
import script from "./SelectionType.vue?vue&type=script&lang=ts"
export * from "./SelectionType.vue?vue&type=script&lang=ts"

import "./SelectionType.vue?vue&type=style&index=0&id=24ec6312&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-24ec6312"

export default script